import { Outlet } from 'react-router-dom';
import { Logo } from '@/components/Logo';

export default function SimpleLayout() {
  return (
    <>
      <header className="top-0 left-0 leading-0 w-full absolute pt-4-0 px-4-0">
        <Logo />
      </header>
      <Outlet />
    </>
  );
}
